import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function QualificationsIcon({ className }: IconProps) {
  return (
    <svg
      width="104"
      height="61"
      viewBox="0 0 104 61"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2000)">
        <path
          d="M99.5649 8.63184H4.43505C1.98564 8.63184 0 10.6141 0 13.0594V56.5724C0 59.0176 1.98564 60.9999 4.43505 60.9999H99.5649C102.014 60.9999 104 59.0176 104 56.5724V13.0594C104 10.6141 102.014 8.63184 99.5649 8.63184Z"
          fill="#00416B"
        />
        <path
          d="M52.0098 60.9998C52.0098 60.9998 61.383 57.8373 76.4584 57.8373C91.5339 57.8373 100.907 60.9998 100.907 60.9998C100.907 60.9998 91.1425 51.7168 76.4584 51.7168C61.7743 51.7168 52.0098 60.9998 52.0098 60.9998Z"
          fill="#DFE2E9"
        />
        <path
          d="M52.0098 61V8.92958C52.0098 8.92958 75.2285 -11.1433 100.926 8.92958V61.0186C100.926 61.0186 77.297 43.792 52.0098 61.0186V61Z"
          fill="#DFE2E9"
        />
        <path
          d="M64.1035 11.0504C70.6815 8.53898 79.4398 7.19955 89.0739 11.0504"
          stroke="#00416B"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M58.8857 21.8958C66.4887 17.7287 79.5329 13.543 94.0121 21.8958"
          stroke="#00416B"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M58.8857 30.3231C66.4887 26.1559 79.5329 21.9702 94.0121 30.3231"
          stroke="#00416B"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M58.8857 38.7694C66.4887 34.6022 79.5329 30.4165 94.0121 38.7694"
          stroke="#00416B"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M58.8857 47.1966C66.4887 43.0295 79.5329 38.8437 94.0121 47.1966"
          stroke="#00416B"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M3.09375 60.9998C3.09375 60.9998 12.467 57.8373 27.5424 57.8373C42.6178 57.8373 51.9911 60.9998 51.9911 60.9998C51.9911 60.9998 42.2265 51.7168 27.5424 51.7168C12.8583 51.7168 3.09375 60.9998 3.09375 60.9998Z"
          fill="#B0B9CF"
        />
        <path
          d="M3.09375 61V8.92958C3.09375 8.92958 26.3125 -11.1433 52.0097 8.92958V61.0186C52.0097 61.0186 28.381 43.792 3.09375 61.0186V61Z"
          fill="#EAEDF8"
        />
        <path
          d="M15.1875 11.0504C21.7655 8.53898 30.5238 7.19955 40.1579 11.0504"
          stroke="#00C4B3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M9.98828 21.8958C17.5912 17.7287 30.6355 13.543 45.1146 21.8958"
          stroke="#00C4B3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M9.98828 30.3231C17.5912 26.1559 30.6355 21.9702 45.1146 30.3231"
          stroke="#00C4B3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M9.98828 38.7694C17.5912 34.6022 30.6355 30.4165 45.1146 38.7694"
          stroke="#00C4B3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M9.98828 47.1966C17.5912 43.0295 30.6355 38.8437 45.1146 47.1966"
          stroke="#00C4B3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M52.0098 60.9998C52.0098 60.9998 61.383 57.8373 76.4584 57.8373C91.5339 57.8373 100.907 60.9998 100.907 60.9998C100.907 60.9998 91.1425 51.7168 76.4584 51.7168C61.7743 51.7168 52.0098 60.9998 52.0098 60.9998Z"
          fill="#B0B9CF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2000">
          <rect width="104" height="61" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
